export enum BettingSideEnum {
    Home = 'home',
    Away = 'away',
    Over = 'over',
    Under = 'under'
}